import { PageMeta } from 'constants/pages';
import { ArticleSections } from 'types/articles';
// import {
//   usingSyntheticDataFromAILiveSimData,
//   usingSyntheticDataFromAILiveSimMeta,
// } from './using-synthetic-data-from-AILiveSim';

interface WhitePaperParameters {
  pageMeta: PageMeta;
  articleData: ArticleSections[];
}

export const WHITEPAPERS: WhitePaperParameters[] = [
  // {
  //   pageMeta: usingSyntheticDataFromAILiveSimMeta,
  //   articleData: usingSyntheticDataFromAILiveSimData,
  // },
];
